<div>
  @if (showHeader) {
    <div class="d-flex mb-4 flex-column align-items-start flex-lg-row align-items-lg-end mt-2">
      <h4 class="me-2 mb-0">{{ 'orderProcess.payment.contactForm.title' | translate }}</h4>

      <div class="text-primary cursor-pointer font-md d-none d-sm-block"
           [translate]="'orderProcess.payment.whyDoAskInfo.question'"
           [ngbTooltip]="'orderProcess.payment.whyDoAskInfo.answer' | translate">
      </div>
    </div>
  }

  <div>
    <payment-contact-info-b
      [countryCode]="countryCode"
      [userInfo]="contactInfo"
      [askForReferenceField]="false"
      [personType]="privatePaymentType"
      [bakeryId]="bakeryId"
      [useCompanySearcher]="true"
      (onValidUpdated)="onContactInfoValidated($event)"
      (onInfoUpdated)="onContactInfoUpdated($event); errorMsg=''"
      (onCompanySelected)="onCompanySelected($event)"
    ></payment-contact-info-b>

    <ng-content select=".gift-card-and-promo-code"></ng-content>

    <ng-content select=".payment-method-selector"></ng-content>
  </div>


  <div class="d-flex mt-2rem mb-4 flex-column align-items-start flex-lg-row align-items-lg-end">
    <h4 class="me-2 mb-0">{{ 'orderProcess.payment.invoice.title' | translate }}</h4>
  </div>

  <user-invoice-info
    [countryCode]="countryCode"
    [paymentInfo]="contactInfo"
    [isForPayment]="true"
    [invoiceInfo]="invoiceInfo"
    [user]="user"
    [bakeryId]="bakeryId"
    [isSharedBusinessAccount]="isSharedBusinessAccount"
    [allowToChangeCountry]="allowToChangeCountry"
    [showInvoiceFormat]="showInvoiceFormat"
    [companyChangeActions]="companyChangeActions"
    [(isValid)]="isInvoiceInfoValid"
    (onInvoiceUpdated)="onUpdated($event); errorMsg=''"
    (onChangeCompanyClick)="errorMsg=''"
    (onCompanyChosen)="onInvoiceCompanySelected($event)"
  ></user-invoice-info>

  @if (errorMsg) {
    <ui-message class="d-block mt-4"
                [type]="'error'">
      {{ errorMsg }}
    </ui-message>
  }


  <button class="btn btn-pink payment-confirm-btn my-4"
          [disabled]="!isInvoiceInfoValid || !isContactInfoFilled"
          (click)="createInvoiceOrder(invoiceInfo, contactInfo)">
    {{ 'orderProcess.payment.confirmOrder' | translate }}
  </button>

  <terms-and-conditions (onTermsClick)="onTermsClick.emit()">
  </terms-and-conditions>
</div>
